import { Content } from './label.styled';

export const Label = (props) => {
  const { children, ...rest } = props;

  return <Content {...rest}>{children}</Content>;
};
